//
//
//
//
//
//
//
//
//

  export default {
    name: "robotchatmessage",
    components: {
      
    },
    props: {
        stringText:String, //显示聊天内容
        speed:Number, //显示速度 毫秒/字
        playState:Boolean,//播放文本按钮状态
        itemID:String,
    },
    data() {
      return {
        displayMessage:"",
        totalMessage:this.stringText || "",
        intervalHandler:undefined,
        displayIndex:0,
        disSpeed:this.speed,
        playTextVoiceSatate:this.playState,
      };
    }, 
    mounted() {
        this.init()
    },
    beforeDestroy() {}, 
    methods: {
      init(){
          if(this.disSpeed<=0){
             this.displayMessage=this.totalMessage
             this.displayIndex=this.totalMessage.length
             this.$emit('onTextShowAccomplish',{itemID:this.itemID})
             return
          }
          if(this.intervalHandler) clearInterval(this.intervalHandler)
          this.displayIndex=0
          this.displayMessage=""
          this.intervalHandler = setInterval(()=>{
            if(this.displayIndex>=this.totalMessage.length){
              clearInterval(this.intervalHandler)
              this.disSpeed=0
              this.$emit('onTextShowAccomplish',{itemID:this.itemID})
              return
            }
            this.displayMessage+=this.totalMessage[this.displayIndex++]
           
          },this.disSpeed)
      },
      getCurShowLength(){
        return this.displayMessage.length
      },
      //播放文字语音
      onPlayTextVoice()
      {
        
        // let url = '/static/img/蓝心羽 - 好想爱这个世界啊 (片段).mp3'  //播放地址
        this.$emit('onPlayText')
      },
    },
    watch: {
      speed(value){
        console.log('----------change speed',value)
        this.disSpeed=value
      },
      playState(value){
        this.playTextVoiceSatate=value
      },
      stringText(value){
        this.totalMessage=value
      }
    },
    expose:{

    }
  };
  


// WEBPACK FOOTER //
// ./src/myComponents/TypeMessage/TypeMessage.vue